import React, { useEffect, useState } from "react";
import { LoginProps } from "./Login";
import QRCode from "qrcode";
import { useLocation, useNavigate } from "react-router-dom";

const QRCodeScreen = ({ loginAccount, setStep, carUuid }: LoginProps) => {
  const [qrCodeImgUrl, set_qrCodeImgUrl] = useState<string>(
    `${process.env.PUBLIC_URL}/img/loginQR.png`
  );
  const navigate = useNavigate();

  const goNextStep = () => {
    /*
    if (setStep) {
      if (loginAccount.length > 0) setStep(5);
      else setStep(4);
    }
    */
    navigate("/home", { replace: true });
  };

  const generateQrCode = async () => {
    let sUrl = "https://api-stg.throo.kr/obigo/login/qr/" + carUuid;
    const BufferQRCode: any = await QRCode.toDataURL(sUrl, { width: 162 });
    set_qrCodeImgUrl(BufferQRCode);
  };

  useEffect(() => {
    generateQrCode();
  }, []);

  return (
    <div className="wrapper">
      <img
        src={`${process.env.PUBLIC_URL}/svg/throoLogo.svg`}
        alt="스루로고"
        className="logo"
      />
      <div>
        <img
          src={`${qrCodeImgUrl}`}
          onClick={goNextStep}
          alt="로그인 qr코드"
          style={{
            maxWidth: "162px",
          }}
        />
        {loginAccount.length > 0 && loginAccount ? (
          <h2>
            사용자를 추가합니다. <br />
            QR화면에서 등록 가능합니다.
          </h2>
        ) : (
          <h2>
            등록된 사용자가 없습니다. <br />
            QR화면에서 등록 가능합니다.
          </h2>
        )}
      </div>
    </div>
  );
};
export default QRCodeScreen;
